// ============================================================
// 커피 주문 데모 목업 데이터
// ============================================================

import { MenuItem, Order, Settlement, Robot, AdminAccount, StoreSettings, OperatingHours, DemoAccounts } from '../types'

export const MOCK_MENU_ITEMS: MenuItem[] = [
  { id: '1', name: '아메리카노', originalPrice: 4500, discountedPrice: 4500, discount: 0, image: '/demos/coffee-order/menu-americano.png', category: '음료', status: '판매중' },
  { id: '2', name: '카페라떼', originalPrice: 5000, discountedPrice: 4500, discount: 10, image: '/demos/coffee-order/menu-latte.png', category: '음료', status: '판매중' },
  { id: '3', name: '바닐라라떼', originalPrice: 5500, discountedPrice: 4950, discount: 10, image: '/demos/coffee-order/menu-vanilla-latte.png', category: '음료', status: '판매중' },
  { id: '4', name: '카푸치노', originalPrice: 5000, discountedPrice: 5000, discount: 0, image: '/demos/coffee-order/menu-cappuccino.png', category: '음료', status: '판매중' },
  { id: '5', name: '에스프레소', originalPrice: 3500, discountedPrice: 3500, discount: 0, image: '/demos/coffee-order/menu-espresso.png', category: '음료', status: '판매중' },
  { id: '6', name: '콜드브루', originalPrice: 5500, discountedPrice: 4950, discount: 10, image: '/demos/coffee-order/menu-coldbrew.png', category: '음료', status: '판매중' },
  { id: '7', name: '초코 케이크', originalPrice: 6000, discountedPrice: 6000, discount: 0, image: '/demos/coffee-order/menu-choco-cake.png', category: '디저트', status: '판매중' },
  { id: '8', name: '치즈 케이크', originalPrice: 6500, discountedPrice: 5850, discount: 10, image: '/demos/coffee-order/menu-cheese-cake.png', category: '디저트', status: '판매중' },
]

export const MOCK_ORDERS: Order[] = [
  // 주문접수 (received) - 4건
  {
    id: '1',
    order_number: 'ORD-001',
    status: 'received',
    delivery_method: 'robot',
    delivery_location: '3층 회의실 A',
    total_amount: 14000,
    order_time: new Date(Date.now() - 1000 * 60 * 2).toISOString(),
    items: [
      { id: '1', name: '아메리카노', quantity: 2, total_price: 9000 },
      { id: '7', name: '초코 케이크', quantity: 1, total_price: 5000 }
    ]
  },
  {
    id: '2',
    order_number: 'ORD-002',
    status: 'received',
    delivery_method: 'pickup',
    delivery_location: '카운터',
    total_amount: 8500,
    order_time: new Date(Date.now() - 1000 * 60 * 3).toISOString(),
    items: [
      { id: '2', name: '카페라떼', quantity: 1, total_price: 4500 },
      { id: '3', name: '바닐라라떼', quantity: 1, total_price: 4000 }
    ]
  },
  {
    id: '3',
    order_number: 'ORD-003',
    status: 'received',
    delivery_method: 'robot',
    delivery_location: '5층 개발팀',
    total_amount: 18000,
    order_time: new Date(Date.now() - 1000 * 60 * 5).toISOString(),
    items: [
      { id: '1', name: '아메리카노', quantity: 3, total_price: 13500 },
      { id: '6', name: '크로와상', quantity: 1, total_price: 4500 }
    ]
  },
  {
    id: '4',
    order_number: 'ORD-004',
    status: 'received',
    delivery_method: 'pickup',
    delivery_location: '카운터',
    total_amount: 6500,
    order_time: new Date(Date.now() - 1000 * 60 * 7).toISOString(),
    items: [
      { id: '4', name: '콜드브루', quantity: 1, total_price: 6500 }
    ]
  },
  // 준비중 (preparing) - 3건
  {
    id: '5',
    order_number: 'ORD-005',
    status: 'preparing',
    delivery_method: 'robot',
    delivery_location: '4층 마케팅팀',
    total_amount: 21000,
    order_time: new Date(Date.now() - 1000 * 60 * 10).toISOString(),
    items: [
      { id: '2', name: '카페라떼', quantity: 2, total_price: 9000 },
      { id: '7', name: '초코 케이크', quantity: 2, total_price: 12000 }
    ]
  },
  {
    id: '6',
    order_number: 'ORD-006',
    status: 'preparing',
    delivery_method: 'pickup',
    delivery_location: '카운터',
    total_amount: 9500,
    order_time: new Date(Date.now() - 1000 * 60 * 12).toISOString(),
    items: [
      { id: '5', name: '녹차라떼', quantity: 1, total_price: 5000 },
      { id: '6', name: '크로와상', quantity: 1, total_price: 4500 }
    ]
  },
  {
    id: '7',
    order_number: 'ORD-007',
    status: 'preparing',
    delivery_method: 'robot',
    delivery_location: '2층 디자인팀',
    total_amount: 13500,
    order_time: new Date(Date.now() - 1000 * 60 * 15).toISOString(),
    items: [
      { id: '1', name: '아메리카노', quantity: 3, total_price: 13500 }
    ]
  },
  // 배송중/픽업대기 (delivering, pickup_waiting) - 4건
  {
    id: '8',
    order_number: 'ORD-008',
    status: 'delivering',
    delivery_method: 'robot',
    delivery_location: '6층 경영지원팀',
    total_amount: 17500,
    order_time: new Date(Date.now() - 1000 * 60 * 20).toISOString(),
    items: [
      { id: '3', name: '바닐라라떼', quantity: 2, total_price: 10000 },
      { id: '8', name: '치즈 케이크', quantity: 1, total_price: 6500 }
    ]
  },
  {
    id: '9',
    order_number: 'ORD-009',
    status: 'delivering',
    delivery_method: 'robot',
    delivery_location: '3층 인사팀',
    total_amount: 9000,
    order_time: new Date(Date.now() - 1000 * 60 * 22).toISOString(),
    items: [
      { id: '1', name: '아메리카노', quantity: 2, total_price: 9000 }
    ]
  },
  {
    id: '10',
    order_number: 'ORD-010',
    status: 'pickup_waiting',
    delivery_method: 'pickup',
    delivery_location: '카운터',
    total_amount: 11000,
    order_time: new Date(Date.now() - 1000 * 60 * 25).toISOString(),
    items: [
      { id: '4', name: '콜드브루', quantity: 1, total_price: 6500 },
      { id: '6', name: '크로와상', quantity: 1, total_price: 4500 }
    ]
  },
  {
    id: '11',
    order_number: 'ORD-011',
    status: 'pickup_waiting',
    delivery_method: 'pickup',
    delivery_location: '카운터',
    total_amount: 5000,
    order_time: new Date(Date.now() - 1000 * 60 * 28).toISOString(),
    items: [
      { id: '5', name: '녹차라떼', quantity: 1, total_price: 5000 }
    ]
  },
  // 완료 (completed) - 4건
  {
    id: '12',
    order_number: 'ORD-012',
    status: 'completed',
    delivery_method: 'robot',
    delivery_location: '7층 임원실',
    total_amount: 25000,
    order_time: new Date(Date.now() - 1000 * 60 * 60).toISOString(),
    items: [
      { id: '2', name: '카페라떼', quantity: 2, total_price: 9000 },
      { id: '7', name: '초코 케이크', quantity: 1, total_price: 6000 },
      { id: '8', name: '치즈 케이크', quantity: 1, total_price: 6500 }
    ]
  },
  {
    id: '13',
    order_number: 'ORD-013',
    status: 'completed',
    delivery_method: 'pickup',
    delivery_location: '카운터',
    total_amount: 4500,
    order_time: new Date(Date.now() - 1000 * 60 * 90).toISOString(),
    items: [
      { id: '1', name: '아메리카노', quantity: 1, total_price: 4500 }
    ]
  },
  {
    id: '14',
    order_number: 'ORD-014',
    status: 'completed',
    delivery_method: 'robot',
    delivery_location: '4층 회의실 B',
    total_amount: 32000,
    order_time: new Date(Date.now() - 1000 * 60 * 120).toISOString(),
    items: [
      { id: '1', name: '아메리카노', quantity: 4, total_price: 18000 },
      { id: '6', name: '크로와상', quantity: 2, total_price: 9000 },
      { id: '5', name: '녹차라떼', quantity: 1, total_price: 5000 }
    ]
  },
  {
    id: '15',
    order_number: 'ORD-015',
    status: 'completed',
    delivery_method: 'pickup',
    delivery_location: '카운터',
    total_amount: 10000,
    order_time: new Date(Date.now() - 1000 * 60 * 180).toISOString(),
    items: [
      { id: '3', name: '바닐라라떼', quantity: 2, total_price: 10000 }
    ]
  }
]

export const MOCK_SETTLEMENTS: Settlement[] = [
  { id: '1', date: '2025-11-26', orders: 57, sales: 285000, fee: 28500, settlement: 256500, status: '정산완료', paymentMethod: '카드 80% / 현금 20%' },
  { id: '2', date: '2025-11-25', orders: 48, sales: 240000, fee: 24000, settlement: 216000, status: '정산완료', paymentMethod: '카드 75% / 현금 25%' },
  { id: '3', date: '2025-11-24', orders: 62, sales: 310000, fee: 31000, settlement: 279000, status: '정산완료', paymentMethod: '카드 82% / 현금 18%' },
  { id: '4', date: '2025-11-23', orders: 41, sales: 205000, fee: 20500, settlement: 184500, status: '정산완료', paymentMethod: '카드 78% / 현금 22%' },
  { id: '5', date: '2025-11-22', orders: 55, sales: 275000, fee: 27500, settlement: 247500, status: '정산완료', paymentMethod: '카드 85% / 현금 15%' },
  { id: '6', date: '2025-11-21', orders: 39, sales: 195000, fee: 19500, settlement: 175500, status: '정산완료', paymentMethod: '카드 70% / 현금 30%' },
  { id: '7', date: '2025-11-20', orders: 52, sales: 260000, fee: 26000, settlement: 234000, status: '정산대기', paymentMethod: '카드 77% / 현금 23%' },
]

export const MOCK_ROBOTS: Robot[] = [
  { id: 'R001', name: '배송봇 1호', status: '운행중', battery: 85, location: '3층 회의실', deliveries: 23, lastDelivery: '2025-11-26 14:30' },
  { id: 'R002', name: '배송봇 2호', status: '대기중', battery: 92, location: '1층 충전소', deliveries: 18, lastDelivery: '2025-11-26 13:45' },
  { id: 'R003', name: '배송봇 3호', status: '충전중', battery: 35, location: '1층 충전소', deliveries: 31, lastDelivery: '2025-11-26 12:20' },
  { id: 'R004', name: '배송봇 4호', status: '운행중', battery: 67, location: '5층 개발팀', deliveries: 27, lastDelivery: '2025-11-26 14:25' },
  { id: 'R005', name: '배송봇 5호', status: '점검중', battery: 100, location: '정비실', deliveries: 15, lastDelivery: '2025-11-25 18:00' },
]

export const MOCK_ADMINS: AdminAccount[] = [
  { id: '1', name: '김점주', email: 'owner@coffee.com', role: '점주', status: '활성', lastLogin: '2025-11-26 14:30', createdAt: '2025-06-15' },
  { id: '2', name: '이매니저', email: 'manager@coffee.com', role: '매니저', status: '활성', lastLogin: '2025-11-26 09:15', createdAt: '2025-08-20' },
  { id: '3', name: '박직원', email: 'staff1@coffee.com', role: '직원', status: '활성', lastLogin: '2025-11-25 18:45', createdAt: '2025-10-01' },
  { id: '4', name: '최직원', email: 'staff2@coffee.com', role: '직원', status: '활성', lastLogin: '2025-11-26 08:00', createdAt: '2025-11-15' },
  { id: '5', name: '정직원', email: 'staff3@coffee.com', role: '직원', status: '비활성', lastLogin: '2025-11-10 12:00', createdAt: '2025-09-01' },
]

export const MOCK_STORE_SETTINGS: StoreSettings = {
  store_name: '데모 커피숍',
  store_location: '서울시 강남구 테헤란로 123',
  phone_number: '02-1234-5678',
  business_name: '(주)데모커피',
  business_number: '123-45-67890',
  business_address: '서울시 강남구 테헤란로 123, 데모빌딩 1층',
  use_robot_delivery: true,
  is_service_open: true,
}

export const MOCK_OPERATING_HOURS: OperatingHours = {
  monday: { is_open: true, open_time: '09:00', close_time: '22:00' },
  tuesday: { is_open: true, open_time: '09:00', close_time: '22:00' },
  wednesday: { is_open: true, open_time: '09:00', close_time: '22:00' },
  thursday: { is_open: true, open_time: '09:00', close_time: '22:00' },
  friday: { is_open: true, open_time: '09:00', close_time: '23:00' },
  saturday: { is_open: true, open_time: '10:00', close_time: '23:00' },
  sunday: { is_open: true, open_time: '10:00', close_time: '21:00' },
}

export const DEMO_ACCOUNTS: DemoAccounts = {
  storeAdmin: { email: 'store@demo.com', password: 'demo1234', name: '점포 관리자' },
  systemAdmin: { email: 'admin@demo.com', password: 'admin1234', name: '시스템 관리자' },
}
